import Handlebars from "@cirrus/legacy/vendor-bower/handlebars/handlebars"
import { makeHiddenReadableText } from "@cirrus/legacy/app-common/utils/readspeakerUtils.es6"

Handlebars.registerHelper("hiddenReadableText", (text, translate) => {
  return new Handlebars.SafeString(makeHiddenReadableText(text, translate))
})
